import React, { useEffect, useState } from 'react';
import { usePatient } from '../../../../../Contexts/PatientContext';
import styles from './style.module.css';
import LeftIcon from '../leftIcon.svg';
import HealthCustomCard from '../../../../../Components/HealthCustomCard';
import ProfileImage from '../images/profile.svg';
import * as moment from 'moment';
import Modal from '../../../../../Components/Modal';
import DatePicker from '../../../../../Components/DatePicker';
import { createTreatment, updateProduct, upsertCustomer, linkMedicationToTreatment } from '../../../../../services/kollectaHealthCore';
import Papa from 'papaparse';
import Select from 'react-select';
import modalRed from '../redModalIcon.svg';
import modalGreen from '../greenModalIcon.svg';
import editIcon from './edit.svg';

const Profile = ({ onAddTreatment }) => {
  const { patientData, addTreatment, updatePatient } = usePatient();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [genderModalOpen, setGenderModalOpen] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [editData, setEditData] = useState({
    productId: '',
    purpose: '',
    previousSystemicOncoTherapy: false,
    previousOncoSurgery: false,
    previousRadiationTherapy: false,
    currentProtocol: [],
    gender: '',
    status: 'imported',
  });
  const [localPatientData, setLocalPatientData] = useState({});

  const statusLabels = {
    'imported': 'Ativo',
    'obito_por_cancer': 'Óbito por câncer',
    'obito_por_outra_causa': 'Óbito por outra causa',
    'obito_desconhecido': 'Óbito desconhecido',
    'saida_do_estudo_por_opcao': 'Saída do estudo por opção',
    'erro_no_cadastro': 'ERRO NO CADASTRO',
    'dor_controlada': 'DOR CONTROLADA',
  };

  const handleEdit = (item) => {
    setEditData(item);
    setEditModalOpen(true);
  };

  const handleEditGender = () => {
    setGenderModalOpen(true);
  };

  const handleSaveGender = async () => {
    try {
      const updatedData = {
        personalNumber: patientData?.customer?.personalNumber,
        name: patientData?.customer?.name,
        email: patientData?.customer?.email,
        phone: patientData?.customer?.phone,
        gender: editData.gender,
      };

      await upsertCustomer(updatedData);
      updatePatient({ ...patientData, customer: { ...patientData.customer, gender: editData.gender } });
      setSuccessModal(true);
    } catch (error) {
      setErrorModal(true);
      console.error('Erro ao atualizar o gênero:', error);
    } finally {
      setGenderModalOpen(false);
    }
  };

  const handleConfirmStatusSave = async () => {
    try {
      await updateProduct(patientData.id, { status: editData.status });

      setLocalPatientData((prev) => ({
        ...prev,
        status: editData.status,
      }));

      console.log('Status do tratamento atualizado com sucesso!');
      setSuccessModal(true);
    } catch (error) {
      console.error('Erro ao atualizar o status do tratamento:', error);
      setErrorModal(true);
    } finally {
      setEditModalOpen(false);
    }
  };

  useEffect(() => {
    if (patientData && patientData.id) {
      const lastTreatment = patientData?.treatments?.[patientData.treatments.length - 1] || {};
      
      setEditData({
        productId: patientData.id,
        purpose: lastTreatment?.purpose || '',
        previousSystemicOncoTherapy: lastTreatment?.previousSystemicOncoTherapy || false,
        previousOncoSurgery: lastTreatment?.previousOncoSurgery || false,
        previousRadiationTherapy: lastTreatment?.previousRadiationTherapy || false,
        currentProtocol: lastTreatment?.currentProtocol ? [...lastTreatment.currentProtocol] : [],
        gender: patientData?.customer?.gender || '',
        status: patientData?.status || 'imported',
        startDate: lastTreatment?.startDate ? new Date(lastTreatment.startDate) : new Date(),
      });
      
      setLocalPatientData(patientData);
    }
  }, [patientData]);

  return (
    <>
      <HealthCustomCard>
        <div className={styles.profileCard}>
          <div className={styles.profileCardLeft}>
            <div className={styles.profileCardLeftTop}>
              <img src={ProfileImage} alt="Kollecta Health" />
              <h1>{patientData?.customer?.name}</h1>
            </div>

            <div className={styles.profileCardLeftInfos}>
              <div className={styles.profileCardLeftContent}>
                <p>
                  <span>CPF</span>
                  {patientData?.customer?.personalNumber}
                </p>

                <p>
                  <span>Data de Nascimento</span>
                  {moment(patientData?.customer?.birthday).format('DD/MM/YYYY')}
                </p>
              </div>

              <div className={styles.profileCardLeftContent}>
                <p>
                  <span>Celular</span>
                  {patientData?.customer?.phone}
                </p>
              </div>
            </div>
          </div>

          <div className={styles.profileCardRight}>
            <div className={styles.subtitle}>
              <h3> Informações do Estudo </h3>
              <img src={LeftIcon} alt="Kollecta Health" />
            </div>

            <div className={styles.profileCardRightContent}>
              <p>
                <span>Data do Estudo Atual</span>
                {moment(patientData?.createdAt).format('DD/MM/YYYY')}
              </p>
            </div>

            <div
              className={`${localPatientData?.status === 'imported' ? styles.statusActive : styles.statusInactive}`}
            >
              <p>
                <span>Condição do Tratamento</span>

                <div className={styles.editContainer}>
                  {statusLabels[localPatientData?.status] || '-'}{' '}
                  <img
                    src={editIcon}
                    alt="Edit"
                    className={styles.editIcon}
                    onClick={() => handleEdit(localPatientData)}
                  />
                </div>
              </p>
            </div>

            <div className={styles.profileCardRightContent}>
              <button 
                className={styles.generalButton}
                onClick={onAddTreatment}
              >
                Alterar Tratamento
              </button>
            </div>
          </div>
        </div>
      </HealthCustomCard>

      {genderModalOpen && (
        <Modal onClose={() => setGenderModalOpen(false)}>
          <div className={styles.containerModal}>
            <h2>Editar Gênero</h2>
            <select
              value={editData.gender}
              onChange={(e) => setEditData({ ...editData, gender: e.target.value })}
              className={styles.selectStyle}
            >
              <option value="Masculino">Masculino</option>
              <option value="Feminino">Feminino</option>
            </select>
            <div className={styles.buttonsContainer}>
              <button onClick={handleSaveGender} className={styles.buttonSuccess}>
                Salvar
              </button>
              <button onClick={() => setGenderModalOpen(false)} className={styles.buttonError}>
                Cancelar
              </button>
            </div>
          </div>
        </Modal>
      )}

      {successModal && (
        <Modal onClose={() => setSuccessModal(false)}>
          <div className={styles.containerModal}>
            <img src={modalGreen} alt="Green Modal Icon" />
            <h2>Alteração realizada!</h2>
          </div>
        </Modal>
      )}

      {errorModal && (
        <Modal onClose={() => setErrorModal(false)}>
          <div className={styles.containerModal}>
            <img src={modalRed} alt="Red Modal Icon" />
            <h2>Erro ao adicionar tratamento!</h2>
            <p> Tente novamente </p>
          </div>
        </Modal>
      )}

      {editModalOpen && (
        <Modal onClose={() => setEditModalOpen(false)}>
          <div className={styles.containerModal}>
            <h2>Editar Condição do Tratamento</h2>
            <select
              value={editData.status}
              onChange={(e) => setEditData({ ...editData, status: e.target.value })}
              className={styles.selectStyle}
            >
              {Object.entries(statusLabels).map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
            <div className={styles.buttonsContainer}>
              <button onClick={handleConfirmStatusSave} className={styles.buttonSuccess}>
                Salvar
              </button>
              <button onClick={() => setEditModalOpen(false)} className={styles.buttonError}>
                Cancelar
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Profile;
